import { fromJS } from 'immutable';
import combineReducers from '../../../utilities/combineReducers';
import actions from '../constants';
import clock from './clock';
import entities from './entities';
import period from './period';
import ui from './ui';

const initialState = fromJS({});

const codingReducers = combineReducers({
  clock,
  entities,
  period,
  ui
});

export default (state = initialState, action) => {
  const codingActionTypes = Object.values(actions).filter(
    x => !x.endsWith('_ERROR')
  );

  if (!codingActionTypes.includes(action.type)) {
    return state;
  }

  return state.update(action.payload.gameId, initialState, x =>
    codingReducers(x, action)
  );
};



// WEBPACK FOOTER //
// ./src/modules/coding/reducers/index.js